const InsuranceCard = ({ imageUrl, label }: { imageUrl?: string | null; label: string }) => {
  return (
    <div>
      <p className="font-semibold mb-2">{label}</p>
      {imageUrl ? (
        <img
          loading="lazy"
          alt={label}
          className="h-auto w-72 max-w-full aspect-3/2 rounded-lg"
          src={imageUrl}
        />
      ) : (
        <div
          className={
            ' bg-gray-200 opacity-50 btn h-auto w-72 max-w-full aspect-3/2 inline-flex items-center justify-center shadow-md border border-dashed border-gray-400 rounded-lg'
          }>
          <span className="p-2 bg-white">No {label} image</span>
        </div>
      )}
    </div>
  );
};

export default InsuranceCard;
